import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col, Container, FormText } from "react-bootstrap";
import { Formik, Field } from "formik";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

import { Stepper, Step } from "react-form-stepper";

import SubmitFormPreview from "./SubmitFormPreview";
const FormType = {
  Umrlica: "Umrlica",
  Pomen: "Pomen",
  PoslednjiPozdrav: "Poslednji pozdrav",
};
const FormSize = {
  Large: 3,
  Medium: 2,
  Small: 1,
  Tiny: 4,
};

const getFormSizeName = (s) => {
  let name = "";

  if (s === FormSize.Large) {
    name = "Velika";
  } else if (s === FormSize.Medium) {
    name = "Srednja";
  } else if (s === FormSize.Small) {
    name = "Mala";
  } else if (s === FormSize.Tiny) {
    name = "Najmanja";
  }

  return name;
};
const multipleImages = localStorage.getItem("multipleImages");
let uploadedImagePaths = [];
const SubmitForm = (formType, formSize, cities, multiple) => {
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedIconUrl, setSelectedIconUrl] = useState("");
  const [step, setStep] = useState(0);
  const [formValues, setFormValues] = useState();
  const userRole = localStorage.getItem("userRole");
  const [deathDate, setDeathDate] = useState();
  const [birthDate, setBirthDate] = useState();

  const [age, setAge] = useState();

  useEffect(() => {
    const deathDateObj = new Date(deathDate);
    const birthDateObj = new Date(birthDate);

    const deathYear = parseInt(deathDateObj.getFullYear());
    const birthYear = parseInt(birthDateObj.getFullYear());

    setAge(deathYear - birthYear);
  }, [deathDate, birthDate]);

  Date.prototype.mmddyyyy = function () {
    var mm = this.getMonth() + 1; // getMonth() is zero-based
    var dd = this.getDate();

    return [
      this.getFullYear(),
      (mm > 9 ? "" : "0") + mm,
      (dd > 9 ? "" : "0") + dd,
    ].join("-");
  };

  const handleSubmit = async (values, { resetForm }) => {
    const formData = new FormData();

    formData.append("note", values.note);
    formData.append("phone_number", values.phone_number);

    formData.append("size", formSize);
    formData.append("name", values.name);

    formData.append("main_text", values.main_text);
    formData.append("city", values.city);
    formData.append("images", uploadedImagePaths);
    if (formSize !== FormSize.Tiny) {
      formData.append("icon", selectedIconUrl);
    } else {
      formData.append("icon", "");
    }

    if (formType === FormType.Umrlica) {
      formData.append("type", "umrlica");
      formData.append("checkbox", "umrlica");
      formData.append("birth_date", birthDate.mmddyyyy());
      formData.append("death_date", deathDate.mmddyyyy());
    } else if (formType === FormType.PoslednjiPozdrav) {
      formData.append("type", "poslednji_pozdrav");
      formData.append("checkbox", "poslednji_pozdrav");
    } else if (formType === FormType.Pomen) {
      formData.append("type", "pomen");

      formData.append("checkbox", "pomen");
      formData.append("header_text", values.header_text);
    }
    formData.append("text_top", values.text_top);
    formData.append("text_bottom", values.bottom_text);
    if (age <= 18) {
      formData.append("color", "blue");
    } else if (
      selectedIconUrl ===
      "https://radojicictijanaa.pythonanywhere.com/media/icons/icon4.png"
    ) {
      values.color = "green";
      formData.append("color", "green");
    } else {
      formData.append("color", values.color);
    }

    formData.append("main_text", values.main_text);

    try {
      const response = await axios.post(
        "https://radojicictijanaa.pythonanywhere.com/api/posts/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      NotificationManager.success(
        `${formType} uspješno ${formType === "Umrlica" ? "dodata" : "dodat!"}`
      );
      setTimeout(() => {
        if (userRole === "superadmin") {
          window.location.href = "/user-profile";
        } else {
          window.location.href = "/";
        }
      }, 1000);

      // Reset form values
      resetForm();
    } catch (error) {
      console.error(error);
    }
  };
  let topTextLimit = 100;
  let nameLimit = 40;
  let mainTextLimit = 320;
  let bottomTextLimit = 120;

  if (formSize === FormSize.Medium && formType === FormType.Umrlica) {
    topTextLimit = 100;
    nameLimit = 50;
    mainTextLimit = 360;
    bottomTextLimit = 280;
  } else if (formSize === FormSize.Medium) {
    topTextLimit = 100;
    nameLimit = 40;
    mainTextLimit = 360;
    bottomTextLimit = 120;
  } else if (formSize === FormSize.Large && formType === FormType.Umrlica) {
    topTextLimit = 100;
    nameLimit = 50;
    mainTextLimit = 320;
    bottomTextLimit = 280;
  } else if (formSize === FormSize.Large) {
    topTextLimit = 100;
    nameLimit = 40;
    mainTextLimit = 600;
    bottomTextLimit = 170;
  } else if (formSize === FormSize.Small && formType === FormType.Umrlica) {
    topTextLimit = 80;
    nameLimit = 50;
    mainTextLimit = 200;
    bottomTextLimit = 200;
  } else if (formSize === FormSize.Small) {
    topTextLimit = 60;
    nameLimit = 40;
    mainTextLimit = 150;
    bottomTextLimit = 70;
  }
  const handleReplaceImage = (index) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = (event) => {
      const newImageFile = event.target.files[0];
      const newSelectedImages = [...selectedImages];
      newSelectedImages[index] = newImageFile;

      setSelectedImages(newSelectedImages);
    };
    input.click();
  };
  const handleIncrementDay = () => {
    const newDate = new Date(birthDate);
    newDate.setDate(birthDate.getDate() + 1);
    setBirthDate(newDate);
  };

  const handleDecrementDay = () => {
    const newDate = new Date(birthDate);
    newDate.setDate(birthDate.getDate() - 1);
    setBirthDate(newDate);
  };

  const handleIncrementDeathDay = () => {
    const newDate = new Date(deathDate);
    newDate.setDate(deathDate.getDate() + 1);
    setDeathDate(newDate);
  };

  const handleDecrementDeathDay = () => {
    const newDate = new Date(deathDate);
    newDate.setDate(deathDate.getDate() - 1);
    setDeathDate(newDate);
  };

  const handleAddImage = () => {
    if (multipleImages === "true") {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.onchange = (event) => {
        const newImage = event.target.files[0];
        setSelectedImages([...selectedImages, newImage]);
      };
      input.click();
    } else if (multipleImages === "false") {
      if (selectedImages.length < 1) {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.onchange = (event) => {
          const newImage = event.target.files[0];
          setSelectedImages([...selectedImages, newImage]);
        };
        input.click();
      } else {
        NotificationManager.error(
          "Izabrali ste objavu sa samo jednom fotografijom"
        );
      }
    }
  };

  const handleDeleteImage = (index) => {
    const newSelectedImages = [...selectedImages];
    newSelectedImages.splice(index, 1);
    setSelectedImages(newSelectedImages);
  };
  function extractDate(input) {
    // Ensure that input is a string
    const inputString = String(input);

    // Regular expression to match date patterns
    const datePattern = /\w{3} (\w{3} \d{2} \d{4})/g;

    // Extract date matches from the input
    const dateMatches = inputString.match(datePattern);

    if (dateMatches === null) {
      return [];
    }

    // Initialize an array to store the extracted dates
    const extractedDates = dateMatches.map((dateMatch) => {
      // Parse the date match into a Date object
      const date = new Date(dateMatch);

      // Extract day, month, and year components
      const day = date.getDate();
      const month = date.getMonth() + 1; // Months are 0-indexed, so add 1
      const year = date.getFullYear();

      // Format the date in the desired format (day/month/year)
      return `${day}/${month}/${year}`;
    });

    return extractedDates;
  }

  const stepForward = async (values) => {
    if (age <= 18) {
      values.color = "blue";
    } else if (
      selectedIconUrl ===
      "https://radojicictijanaa.pythonanywhere.com/media/icons/icon4.png"
    ) {
      values.color = "green";
    }
    setFormValues(values);
    if (birthDate > deathDate) {
      return NotificationManager.error(
        `Datum rodjenja ne moze biti veći od datuma smrti.`
      );
    }
    uploadedImagePaths = [];
    if (selectedImages && selectedImages.length > 0) {
      for (const imageFile of selectedImages) {
        let imgFormData = new FormData();
        imgFormData.append("image", imageFile);

        try {
          const response = await axios.post(
            "https://radojicictijanaa.pythonanywhere.com/api/posts/upload_image/",
            imgFormData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
            }
          );

          const imagePath = response.data.path;
          // Check if the imagePath already exists in the uploadedImagePaths
          const existingImageIndex = uploadedImagePaths.findIndex(
            (path) => path === imagePath
          );

          if (existingImageIndex !== -1) {
            // Replace the existing image with the new one
            uploadedImagePaths[existingImageIndex] = imagePath;
          } else {
            // If not found, add the new image path to the array
            uploadedImagePaths.push(imagePath);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
    /*     window.scrollTo({ top: 0, behavior: "smooth" });
    setStep(step + 1);
    NotificationManager.error("Sva polja moraju biti popunjena"); */
    if (formType === "Umrlica") {
      if (formSize === 3) {
        if (
          values.top_text === "" ||
          values.icon === "" ||
          values.name === "" ||
          deathDate === "" ||
          birthDate === "" ||
          uploadedImagePaths.length === 0 ||
          values.bottom_text === "" ||
          values.color === "" ||
          values.main_text === ""
        ) {
          NotificationManager.error("Sva polja moraju biti popunjena");
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setStep(step + 1);
        }
      } else if (formSize === 2) {
        if (
          values.top_text === "" ||
          values.icon === "" ||
          values.name === "" ||
          deathDate === "" ||
          birthDate === "" ||
          uploadedImagePaths.length === 0 ||
          values.bottom_text === "" ||
          values.color === "" ||
          values.main_text === ""
        ) {
          NotificationManager.error("Sva polja moraju biti popunjena");
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setStep(step + 1);
        }
      } else if (formSize === 1) {
        if (
          values.top_text === "" ||
          values.name === "" ||
          deathDate === "" ||
          birthDate === "" ||
          values.main_text === "" ||
          uploadedImagePaths.length === 0 ||
          values.bottom_text === "" ||
          values.color === ""
        ) {
          NotificationManager.error("Sva polja moraju biti popunjena");
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setStep(step + 1);
        }
      } else if (formSize === 4) {
        if (
          values.name === "" ||
          deathDate === "" ||
          birthDate === "" ||
          values.bottom_text === "" ||
          values.color === ""
        ) {
          NotificationManager.error("Sva polja moraju biti popunjena");
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setStep(step + 1);
        }
      }
    } else if (formType === "Pomen") {
      if (formSize === 3) {
        if (
          values.top_text === "" ||
          values.name === "" ||
          values.bottom_text === "" ||
          uploadedImagePaths.length === 0 ||
          values.main_text === ""
        ) {
          NotificationManager.error("Sva polja moraju biti popunjena");
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setStep(step + 1);
        }
      } else if (formSize === 2) {
        if (
          values.top_text === "" ||
          values.name === "" ||
          values.bottom_text === "" ||
          values.main_text === "" ||
          uploadedImagePaths.length === 0 ||
          values.header_text === ""
        ) {
          NotificationManager.error("Sva polja moraju biti popunjena");
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setStep(step + 1);
        }
      } else if (formSize === 1) {
        if (
          values.top_text === "" ||
          values.name === "" ||
          values.city === "" ||
          uploadedImagePaths.length === 0 ||
          values.header_text === ""
        ) {
          NotificationManager.error("Sva polja moraju biti popunjena");
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setStep(step + 1);
        }
      } else if (formSize === 4) {
        if (
          values.name === "" ||
          values.header_text === "" ||
          values.main_text === ""
        ) {
          NotificationManager.error("Sva polja moraju biti popunjena");
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setStep(step + 1);
        }
      }
    } else if (formType === "Poslednji pozdrav") {
      if (formSize === 3) {
        if (
          values.top_text === "" ||
          values.icon === "" ||
          values.name === "" ||
          uploadedImagePaths.length === 0 ||
          values.bottom_text === "" ||
          values.color === "" ||
          values.main_text === ""
        ) {
          NotificationManager.error("Sva polja moraju biti popunjena");
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setStep(step + 1);
        }
      } else if (formSize === 2) {
        if (
          values.top_text === "" ||
          values.name === "" ||
          values.bottom_text === "" ||
          values.color === "" ||
          uploadedImagePaths.length === 0 ||
          values.main_text === ""
        ) {
          NotificationManager.error("Sva polja moraju biti popunjena");
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setStep(step + 1);
        }
      } else if (formSize === 1) {
        if (
          values.top_text === "" ||
          values.name === "" ||
          values.main_text === "" ||
          uploadedImagePaths.length === 0 ||
          values.bottom_text === ""
        ) {
          NotificationManager.error("Sva polja moraju biti popunjena");
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setStep(step + 1);
        }
      } else if (formSize === 4) {
        if (values.name === "" || values.main_text === "") {
          NotificationManager.error("Sva polja moraju biti popunjena");
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setStep(step + 1);
        }
      }
    }
  };

  const stepBack = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    setStep(step - 1);
  };

  return (
    <div>
      <Stepper activeStep={step}>
        <Step label="Informacije o objavi" />

        <Step label="Pregled" />
        <Step label="Potvrda" />
      </Stepper>

      <Formik
        initialValues={{
          name: "",
          text_top: "",
          main_text: "",
          icon: "",
          image: null,
          checkbox: "",
          size: "",
          bottom_text: "",
          color: "",
          header_text: "",
          city: 0,
          note: "",
          phone_number: "",
        }}
        onSubmit={handleSubmit}
      >
        {({ handleSubmit, setFieldValue, values, handleChange }) => (
          <Form
            className="submit-form"
            onSubmit={handleSubmit}
            style={{
              margin: "0 auto",
              marginTop: "3%",
              maxWidth: "1000px",
              padding: "20px",
              backgroundColor: "#f5f5f5",
              borderRadius: "5px",
              border: "1px solid gray",
              marginBottom: "4%",
            }}
          >
            <div>
              {step !== 1 && step !== 2 && (
                <div>
                  <Row>
                    <Col>
                      {" "}
                      <div
                        style={{
                          height: "0.5px",
                          border: "1px solid black",
                          width: "100%",
                          marginTop: "10px",
                        }}
                      ></div>
                    </Col>
                    <Col>
                      <h5 style={{ textAlign: "center", width: "auto" }}>
                        {formType}
                      </h5>
                    </Col>
                    <Col>
                      {" "}
                      <div
                        style={{
                          height: "0.5x",
                          border: "1px solid black",
                          width: "100%",
                          marginTop: "10px",
                        }}
                      ></div>
                    </Col>
                  </Row>
                  {formSize !== 4 && (
                    <Row>
                      <Col lg={4}></Col>
                      <Col lg={4}>
                        <Form.Group controlId="formTopText">
                          <h6>Gornji tekst</h6>
                          <Form.Control
                            placeholder="Unesite gornji tekst..."
                            name="text_top"
                            onChange={handleChange}
                            value={values.text_top}
                            className="FormaZaPopunjavanje-input"
                            style={{ marginTop: "8px" }}
                            maxLength={80} // Set maximum length for the input
                          />
                          <span className="char-counter">
                            {values.text_top.length}/80
                          </span>
                        </Form.Group>
                      </Col>
                      <Col lg={4}></Col>
                    </Row>
                  )}
                  {formSize === 2 && formType === "Umrlica" && (
                    <Row>
                      <Col lg={4}></Col>
                      <Col style={{ marginTop: "3%" }} lg={4}>
                        <h6>Izaberi ikonicu</h6>

                        <Select
                          options={[
                            {
                              value: "Bez ikonice",
                              label: "Bez ikonice",
                            },
                            {
                              value:
                                "https://radojicictijanaa.pythonanywhere.com/media/icons/icon1.png",
                              label: (
                                <img
                                  height={20}
                                  width={20}
                                  src={require("../assets/ikonice/icon1.png")}
                                  alt="Icon 1"
                                />
                              ),
                            },
                            {
                              value:
                                "https://radojicictijanaa.pythonanywhere.com/media/icons/icon2.png",
                              label: (
                                <img
                                  height={20}
                                  width={20}
                                  src={require("../assets/ikonice/icon2.png")}
                                  alt="Icon 2"
                                />
                              ),
                            },
                            {
                              value:
                                "https://radojicictijanaa.pythonanywhere.com/media/icons/icon3.png",
                              label: (
                                <img
                                  height={20}
                                  width={20}
                                  src={require("../assets/ikonice/icon3.png")}
                                  alt="Icon 3"
                                />
                              ),
                            },
                            {
                              value:
                                "https://radojicictijanaa.pythonanywhere.com/media/icons/icon4.png",
                              label: (
                                <img
                                  height={20}
                                  width={20}
                                  src={require("../assets/ikonice/icon4.png")}
                                  alt="Icon 4"
                                />
                              ),
                            },
                          ]}
                          onChange={(selectedOption) => {
                            // Update the selectedIconUrl state
                            setSelectedIconUrl(selectedOption.value);
                            if (
                              selectedIconUrl ===
                              "https://radojicictijanaa.pythonanywhere.com/media/icons/icon4.png"
                            ) {
                            }
                            // Update the "icon" field value
                            setFieldValue("icon", selectedOption.value);
                          }}
                          value={
                            selectedIconUrl && selectedIconUrl !== "Bez ikonice"
                              ? {
                                  value: selectedIconUrl,
                                  label: (
                                    <div>
                                      <img
                                        height={20}
                                        width={20}
                                        src={selectedIconUrl}
                                        alt="Selected Icon"
                                      />
                                      <span style={{ marginLeft: "10px" }}>
                                        Izabrana ikonica
                                      </span>
                                    </div>
                                  ),
                                }
                              : null
                          }
                        />
                      </Col>
                      <Col lg={4}></Col>
                    </Row>
                  )}
                  {formSize === 3 && formType === "Umrlica" && (
                    <Row>
                      <Col lg={4}></Col>
                      <Col style={{ marginTop: "3%" }} lg={4}>
                        <h6>Izaberi ikonicu</h6>

                        <Select
                          options={[
                            {
                              value: "Bez ikonice",
                              label: "Bez ikonice",
                            },
                            {
                              value:
                                "https://radojicictijanaa.pythonanywhere.com/media/icons/icon1.png",
                              label: (
                                <img
                                  height={20}
                                  width={20}
                                  src={require("../assets/ikonice/icon1.png")}
                                  alt="Icon 1"
                                />
                              ),
                            },
                            {
                              value:
                                "https://radojicictijanaa.pythonanywhere.com/media/icons/icon2.png",
                              label: (
                                <img
                                  height={20}
                                  width={20}
                                  src={require("../assets/ikonice/icon2.png")}
                                  alt="Icon 2"
                                />
                              ),
                            },
                            {
                              value:
                                "https://radojicictijanaa.pythonanywhere.com/media/icons/icon3.png",
                              label: (
                                <img
                                  height={20}
                                  width={20}
                                  src={require("../assets/ikonice/icon3.png")}
                                  alt="Icon 3"
                                />
                              ),
                            },
                            {
                              value:
                                "https://radojicictijanaa.pythonanywhere.com/media/icons/icon4.png",
                              label: (
                                <img
                                  height={20}
                                  width={20}
                                  src={require("../assets/ikonice/icon4.png")}
                                  alt="Icon 4"
                                />
                              ),
                            },
                          ]}
                          onChange={(selectedOption) => {
                            // Update the selectedIconUrl state
                            setSelectedIconUrl(selectedOption.value);
                            if (
                              selectedIconUrl ===
                              "https://radojicictijanaa.pythonanywhere.com/media/icons/icon4.png"
                            ) {
                            }
                            // Update the "icon" field value
                            setFieldValue("icon", selectedOption.value);
                          }}
                          value={
                            selectedIconUrl && selectedIconUrl !== "Bez ikonice"
                              ? {
                                  value: selectedIconUrl,
                                  label: (
                                    <div>
                                      <img
                                        height={20}
                                        width={20}
                                        src={selectedIconUrl}
                                        alt="Selected Icon"
                                      />
                                      <span style={{ marginLeft: "10px" }}>
                                        Izabrana ikonica
                                      </span>
                                    </div>
                                  ),
                                }
                              : null
                          }
                        />
                      </Col>
                      <Col lg={4}></Col>
                    </Row>
                  )}
                  {formType === "Pomen" && (
                    <Row>
                      <Col lg={4}></Col>
                      <Col lg={4}>
                        <Form.Group controlId="formHeaderText">
                          <h6>Tekst iznad slike</h6>
                          <Form.Control
                            placeholder="Unesite tekst iznad slike"
                            name="header_text"
                            onChange={handleChange}
                            value={values.header_text}
                            className="FormaZaPopunjavanje-input"
                            style={{ marginTop: "8px" }}
                            maxLength={50} // Set maximum length for the input
                          />
                          <span className="char-counter">
                            {values.header_text.length}/50
                          </span>
                        </Form.Group>
                      </Col>
                      <Col lg={4}></Col>
                    </Row>
                  )}
                  {formSize !== 4 && (
                    <h5 style={{ marginTop: "3%", textAlign: "center" }}>
                      Fotografija
                    </h5>
                  )}
                  {selectedImages.map((image, index) => (
                    <div
                      key={index}
                      style={{
                        marginRight: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {image instanceof File ? (
                          <img
                            src={URL.createObjectURL(image)} // Use createObjectURL to display local image
                            alt={`Izabrana slika ${index}`}
                            style={{
                              maxWidth: "120px",
                              maxHeight: "120px",
                              marginRight: "10px",
                            }}
                          />
                        ) : (
                          <img
                            src={
                              image.startsWith("http")
                                ? image
                                : `https://radojicictijanaa.pythonanywhere.com/` +
                                  image
                            }
                            alt={`Izabrana slika ${index}`}
                            style={{
                              maxWidth: "120px",
                              maxHeight: "120px",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          />
                        )}

                        <div style={{ display: "flex", marginTop: "5px" }}>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleDeleteImage(index)}
                          >
                            X
                          </Button>
                          <Button
                            size="sm"
                            style={{ marginLeft: "5px" }}
                            onClick={() => handleReplaceImage(index)}
                          >
                            Promijeni
                          </Button>
                        </div>
                      </div>
                      <hr
                        style={{
                          maxWidth: "300px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      ></hr>
                    </div>
                  ))}

                  {selectedImages.length < 3 && (
                    <div style={{ marginRight: "20px", marginBottom: "20px" }}>
                      {formSize !== 4 && (
                        <center>
                          <Button
                            variant="success"
                            size="sm"
                            onClick={handleAddImage}
                          >
                            Dodaj
                          </Button>
                        </center>
                      )}
                    </div>
                  )}
                  <Row>
                    <Col lg={4}></Col>
                    <Col lg={4}>
                      <Form.Group controlId="formName">
                        <h6>Ime i prezime</h6>
                        <Form.Control
                          placeholder="Unesite ime i prezime..."
                          name="name"
                          onChange={handleChange}
                          value={values.name}
                          className="FormaZaPopunjavanje-input"
                          style={{ marginTop: "8px" }}
                          maxLength={50}
                        />
                        <span className="char-counter">
                          {values.name.length}/50
                        </span>
                      </Form.Group>
                    </Col>
                    <Col lg={4}></Col>
                  </Row>

                  {formType === FormType.Umrlica && (
                    <div className="container">
                      <h6>Datum rodjenja</h6>
                      <Col xs={12} className="d-flex justify-content-center">
                        <button
                          disabled={!birthDate}
                          style={{
                            border: "none",
                            background: "transparent",
                            padding: "0",
                            margin: "0",
                          }}
                          onClick={handleDecrementDay}
                        >
                          <img
                            src={require("../assets/lijevo.png")}
                            alt="neki tekst"
                            style={{
                              height: "20px",
                              border: "none",
                              margin: "0",
                            }}
                          />
                        </button>
                        <DatePicker
                          name="birth_date"
                          onChange={setBirthDate}
                          value={birthDate}
                          format="dd/MM/y"
                        />
                        <button
                          disabled={!birthDate}
                          style={{
                            border: "none",
                            background: "transparent",
                            padding: "0",
                            margin: "0",
                          }}
                          onClick={handleIncrementDay}
                        >
                          <img
                            src={require("../assets/desno.png")}
                            alt="neki tekst"
                            style={{
                              height: "20px",
                              border: "none",
                              margin: "0",
                            }}
                          />
                        </button>
                      </Col>
                      <h6>Datum smrti</h6>
                      <Col xs={12} className="d-flex justify-content-center">
                        <button
                          disabled={!deathDate}
                          style={{
                            border: "none",
                            background: "transparent",
                            padding: "0",
                            margin: "0",
                          }}
                          onClick={handleDecrementDeathDay}
                        >
                          <img
                            src={require("../assets/lijevo.png")}
                            alt="neki tekst"
                            style={{
                              height: "20px",
                              border: "none",
                              margin: "0",
                            }}
                          />
                        </button>
                        <DatePicker
                          name="death_date"
                          onChange={setDeathDate}
                          value={deathDate}
                          format="dd/MM/y"
                        />
                        <button
                          disabled={!deathDate}
                          style={{
                            border: "none",
                            background: "transparent",
                            padding: "0",
                            margin: "0",
                          }}
                          onClick={handleIncrementDeathDay}
                        >
                          <img
                            src={require("../assets/desno.png")}
                            alt="neki tekst"
                            style={{
                              height: "20px",
                              border: "none",
                              margin: "0",
                            }}
                          />
                        </button>
                      </Col>
                    </div>
                  )}

                  {formSize === 2 && (
                    <Form.Group controlId="formMainText">
                      <h6>Glavni tekst</h6>
                      <Form.Control
                        placeholder="Unesite glavni tekst..."
                        name="main_text"
                        as="textarea"
                        rows={4}
                        onChange={handleChange}
                        value={values.main_text}
                        className="FormaZaPopunjavanje-textarea"
                        style={{ marginTop: "8px" }}
                        maxLength={mainTextLimit} // Set maximum length for the input
                      />
                      <span className="char-counter">
                        {values.main_text.length}/{mainTextLimit}
                      </span>
                    </Form.Group>
                  )}
                  {formSize === 4 && formType === "Pomen" && (
                    <Form.Group controlId="formMainText">
                      <h6>Glavni tekst</h6>
                      <Form.Control
                        placeholder="Unesite glavni tekst..."
                        name="main_text"
                        as="textarea"
                        rows={4}
                        onChange={handleChange}
                        value={values.main_text}
                        className="FormaZaPopunjavanje-textarea"
                        style={{ marginTop: "8px" }}
                        maxLength={50} // Set maximum length for the input
                      />
                      <span className="char-counter">
                        {values.main_text.length}/{50}
                      </span>
                    </Form.Group>
                  )}

                  {formSize === 1 && formType === "Poslednji pozdrav" && (
                    <Form.Group controlId="formMainText">
                      <h6>Glavni tekst</h6>
                      <Form.Control
                        placeholder="Unesite glavni tekst..."
                        name="main_text"
                        as="textarea"
                        rows={4}
                        onChange={handleChange}
                        value={values.main_text}
                        className="FormaZaPopunjavanje-textarea"
                        style={{ marginTop: "8px" }}
                        maxLength={120} // Set maximum length for the input
                      />
                      <span className="char-counter">
                        {values.main_text.length}/{120}
                      </span>
                    </Form.Group>
                  )}

                  {formSize === 1 && formType === "Umrlica" && (
                    <Form.Group controlId="formMainText">
                      <h6>Glavni tekst</h6>
                      <Form.Control
                        placeholder="Unesite glavni tekst..."
                        name="main_text"
                        as="textarea"
                        rows={4}
                        onChange={handleChange}
                        value={values.main_text}
                        className="FormaZaPopunjavanje-textarea"
                        style={{ marginTop: "8px" }}
                        maxLength={120} // Set maximum length for the input
                      />
                      <span className="char-counter">
                        {values.main_text.length}/{120}
                      </span>
                    </Form.Group>
                  )}
                  {formSize === 3 && (
                    <Form.Group controlId="formMainText">
                      <h6>Glavni tekst</h6>
                      <Form.Control
                        placeholder="Unesite glavni tekst..."
                        name="main_text"
                        as="textarea"
                        rows={4}
                        onChange={handleChange}
                        value={values.main_text}
                        className="FormaZaPopunjavanje-textarea"
                        style={{ marginTop: "8px" }}
                        maxLength={mainTextLimit} // Set maximum length for the input
                      />
                      <span className="char-counter">
                        {values.main_text.length}/{mainTextLimit}
                      </span>
                    </Form.Group>
                  )}

                  {formSize === 1 && formType !== "Poslednji pozdrav" && (
                    <Row>
                      <Col lg={6}>
                        <Form.Group controlId="formBottomText">
                          <h6>
                            {formType === FormType.Umrlica
                              ? "Ozalosceni"
                              : "Od"}
                            :
                          </h6>
                          <Form.Control
                            placeholder="Unesite tekst..."
                            name="bottom_text"
                            rows={4}
                            onChange={handleChange}
                            value={values.bottom_text}
                            className="FormaZaPopunjavanje-textarea"
                            style={{ marginTop: "8px" }}
                            maxLength={bottomTextLimit}
                            as="textarea"
                          />
                          <span className="char-counter">
                            {values.bottom_text.length}/{bottomTextLimit}
                          </span>
                        </Form.Group>
                      </Col>
                      <Col lg={6}></Col>
                    </Row>
                  )}
                  {formSize === 1 && formType === "Poslednji pozdrav" && (
                    <Row>
                      <Col lg={6}>
                        <Form.Group controlId="formBottomText">
                          <h6>
                            {formType === FormType.Umrlica
                              ? "Ozalosceni"
                              : "Od"}
                            :
                          </h6>
                          <Form.Control
                            placeholder="Unesite tekst..."
                            name="bottom_text"
                            rows={4}
                            onChange={handleChange}
                            value={values.bottom_text}
                            className="FormaZaPopunjavanje-textarea"
                            style={{ marginTop: "8px" }}
                            maxLength={bottomTextLimit}
                            as="textarea"
                          />
                          <span className="char-counter">
                            {values.bottom_text.length}/{bottomTextLimit}
                          </span>
                        </Form.Group>
                      </Col>
                      <Col lg={6}></Col>
                    </Row>
                  )}

                  {formSize === 2 && formType !== "Umrlica" && (
                    <Row>
                      <Col lg={6}>
                        <Form.Group controlId="formBottomText">
                          <h6>
                            {formType === FormType.Umrlica
                              ? "Ozalosceni"
                              : "Od"}
                            :
                          </h6>
                          <Form.Control
                            placeholder="Unesite tekst..."
                            name="bottom_text"
                            rows={4}
                            onChange={handleChange}
                            value={values.bottom_text}
                            className="FormaZaPopunjavanje-textarea"
                            style={{ marginTop: "8px" }}
                            maxLength={bottomTextLimit}
                            as="textarea"
                          />
                          <span className="char-counter">
                            {values.bottom_text.length}/{bottomTextLimit}
                          </span>
                        </Form.Group>
                      </Col>
                      <Col lg={6}></Col>
                    </Row>
                  )}
                  {formSize === 4 && formType === "Umrlica" && (
                    <Row>
                      <Col lg={6}>
                        <Form.Group controlId="formBottomText">
                          <h6>
                            {formType === FormType.Umrlica
                              ? "Ozalosceni"
                              : "Od"}
                            :
                          </h6>
                          <Form.Control
                            placeholder="Unesite tekst..."
                            name="bottom_text"
                            rows={4}
                            onChange={handleChange}
                            value={values.bottom_text}
                            className="FormaZaPopunjavanje-textarea"
                            style={{ marginTop: "8px" }}
                            maxLength={bottomTextLimit}
                            as="textarea"
                          />
                          <span className="char-counter">
                            {values.bottom_text.length}/{bottomTextLimit}
                          </span>
                        </Form.Group>
                      </Col>
                      <Col lg={6}></Col>
                    </Row>
                  )}

                  {formSize === 2 && formType === "Umrlica" && (
                    <Row>
                      <Col lg={6}>
                        <Form.Group controlId="formBottomText">
                          <h6>
                            {formType === FormType.Umrlica
                              ? "Ozalosceni"
                              : "Od"}
                            :
                          </h6>
                          <Form.Control
                            placeholder="Unesite tekst..."
                            name="bottom_text"
                            rows={4}
                            onChange={handleChange}
                            value={values.bottom_text}
                            className="FormaZaPopunjavanje-textarea"
                            style={{ marginTop: "8px" }}
                            maxLength={bottomTextLimit}
                            as="textarea"
                          />
                          <span className="char-counter">
                            {values.bottom_text.length}/{bottomTextLimit}
                          </span>
                        </Form.Group>
                      </Col>
                      <Col lg={6}></Col>
                    </Row>
                  )}

                  {formSize === 3 && formType === "Umrlica" && (
                    <Row>
                      <Col lg={6}>
                        <Form.Group controlId="formBottomText">
                          <h6>
                            {formType === FormType.Umrlica
                              ? "Ozalosceni"
                              : "Od"}
                            :
                          </h6>
                          <Form.Control
                            placeholder="Unesite tekst..."
                            name="bottom_text"
                            rows={4}
                            onChange={handleChange}
                            value={values.bottom_text}
                            className="FormaZaPopunjavanje-textarea"
                            style={{ marginTop: "8px" }}
                            maxLength={bottomTextLimit}
                            as="textarea"
                          />
                          <span className="char-counter">
                            {values.bottom_text.length}/{bottomTextLimit}
                          </span>
                        </Form.Group>
                      </Col>
                      <Col lg={6}></Col>
                    </Row>
                  )}
                  {/*  {formSize === 3 && formType === "Umrlica" && (
                    <Row>
                      <Col lg={6}>
                        <Form.Group controlId="formBottomText">
                          <h6>
                            {formType === FormType.Umrlica
                              ? "Ozalosceni"
                              : "Od"}
                            :
                          </h6>
                          <Form.Control
                            placeholder="Unesite tekst..."
                            name="bottom_text"
                            rows={4}
                            onChange={handleChange}
                            value={values.bottom_text}
                            className="FormaZaPopunjavanje-textarea"
                            style={{ marginTop: "8px" }}
                            maxLength={bottomTextLimit}
                            as="textarea"
                          />
                          <span className="char-counter">
                            {values.bottom_text.length}/{bottomTextLimit}
                          </span>
                        </Form.Group>
                      </Col>
                      <Col lg={6}></Col>
                    </Row>
                  )} */}
                  <hr></hr>

                  <div>
                    <Row>
                      <Col lg={6}>
                        <Form.Group controlId="formColor">
                          <h6>Izaberi boju</h6>
                          <Form.Control
                            name="color"
                            as="select"
                            onChange={handleChange}
                            value={
                              age <= 18
                                ? "blue"
                                : selectedIconUrl ===
                                  "https://radojicictijanaa.pythonanywhere.com/media/icons/icon4.png"
                                ? "green"
                                : values.color
                            }
                            className="FormaZaPopunjavanje-select"
                            style={{ marginTop: "8px" }}
                          >
                            <option value="">Izaberi boju</option>
                            <option style={{ color: "black" }} value="black">
                              Crna
                            </option>
                            <option
                              style={{
                                color: "black",
                              }}
                              value="blue"
                            >
                              Plava{" "}
                            </option>
                            <option value="green">Zelena</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group controlId="opcije">
                          <h6>Grad:</h6>
                          <Field
                            style={{
                              borderRadius: "8px",
                              padding: "1%",
                              width: "100%",
                            }}
                            name="city"
                            as="select"
                          >
                            {cities.length !== 0 && (
                              <option defaultValue={"Izaberi grad"}>
                                Izaberi grad (nije obavezno)
                              </option>
                            )}

                            {cities.length === 0 && (
                              <option defaultValue={"Izaberi grad"}>
                                Gradovi se ocitavaju...
                              </option>
                            )}
                            {cities.map((city, index) => {
                              return (
                                <option key={index} value={city.id}>
                                  {city.name}
                                </option>
                              );
                            })}
                          </Field>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>
              )}

              {step === 2 && step !== 1 && (
                <div>
                  <h6>Dodatne informacije o objavi (opciono)</h6>
                  <Col sm={6}>
                    <b>
                      {" "}
                      <h5> Email:{localStorage.getItem("loggedInUserName")}</h5>
                    </b>
                  </Col>
                  <Col sm={6}>
                    <Form.Group controlId="formPhoneNumber">
                      <Form.Control
                        type="phone"
                        placeholder="Vaš broj telefona ..."
                        name="phone_number"
                        onChange={handleChange}
                        value={values.phone_number}
                        className="FormaZaPopunjavanje-input"
                        style={{ marginTop: "8px" }}
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={12}>
                    <Form.Group controlId="formNote">
                      <Form.Control
                        placeholder="Napomena o objavi..."
                        name="note"
                        as="textarea"
                        rows={4}
                        onChange={handleChange}
                        value={values.note}
                        className="FormaZaPopunjavanje-textarea"
                        style={{ marginTop: "8px" }}
                      />
                    </Form.Group>
                  </Col>
                </div>
              )}
              {step === 1 && (
                <div>
                  <h3 style={{ textAlign: "center" }}>Pregled umrlice</h3>
                  <SubmitFormPreview
                    size={getFormSizeName(formSize)}
                    type={formType}
                    color={values.color}
                    icon={values.icon}
                    main_text={values.main_text}
                    name={values.name}
                    image={uploadedImagePaths[0]}
                    bottom_text={values.bottom_text}
                    headerText={values.header_text}
                    deathDate={extractDate(deathDate)}
                    birthDate={extractDate(birthDate)}
                    text_top={values.text_top}
                  />
                </div>
              )}
              {/*   {step === 2 && (
                <div>
                  <Container style={modalStyle}>
                    <Row style={{ paddingTop: "1%" }}>
                      <p style={{ paddingRight: "10%" }}>
                        {formValues.text_top}
                      </p>
                    </Row>
                    <Col
                      style={{ marginTop: "30px" }}
                      className="d-flex justify-content-center"
                    >
                      <img
                        id="umrlica-icon"
                        style={{
                          height: "60px",
                          width: "60px",
                          border: "none",
                        }}
                        src={formValues.icon}
                        alt="x"
                      />
                    </Col>
                    <Row style={{ paddingTop: "2%" }}>
                      <Col className="d-flex justify-content-around"></Col>

                      <Col className="d-flex justify-content-around">
                        <img
                          style={{
                            width: "150px",
                            height: "150px",
                            border: "3px solid black",
                          }}
                          src={
                            "https://radojicictijanaa.pythonanywhere.com/" +
                            uploadedImagePaths[0]
                          }
                          alt={`Image`}
                        />
                      </Col>
                      <Col className="d-flex justify-content-around"></Col>
                    </Row>
                    <Row style={{ paddingTop: "2%" }}>
                      <Col
                        style={{ fontWeight: "bold", letterSpacing: "1.2px" }}
                        className="d-flex justify-content-around"
                      >
                        {formValues.name}
                      </Col>
                    </Row>
                    <Col className="d-flex justify-content-around">
                      <span style={{ textAlign: "center" }}>
                        {extractDate(birthDate)}- {extractDate(deathDate)}
                      </span>
                    </Col>
                    <Row>
                      <p style={{ padding: "2%" }}>{formValues.main_text}</p>
                    </Row>{" "}
                    <hr></hr>
                    <Row style={{ padding: "2%" }}>
                      <b>
                        <h5 id="sakrij">Ozalosceni:</h5>
                        <p id="sakrij">{formValues.bottom_text}</p>
                      </b>
                    </Row>
                  </Container>
                </div>
              )} */}
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {step !== 3 && step !== 0 && (
                  <Button
                    className="FormaZaPopunjavanje-continue"
                    type="button"
                    style={{
                      background: "darkred",
                      border: "none",
                      marginTop: "20px",
                    }}
                    onClick={() => stepBack()}
                  >
                    Nazad
                  </Button>
                )}
                {step === 2 && (
                  <Button className="FormaZaPopunjavanje-submit" type="submit">
                    Potvrdi
                  </Button>
                )}
                {step !== 2 && (
                  <Button
                    className="FormaZaPopunjavanje-continue"
                    type="button"
                    onClick={() => stepForward(values)}
                    style={{
                      marginTop: "20px",
                      marginLeft: "auto", // This pushes the button to the right
                    }}
                  >
                    Nastavi
                  </Button>
                )}
              </div>
            </div>

            <NotificationContainer animation={false} />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export { SubmitForm, FormType, FormSize };
